import Image from 'next/image'
import { FC } from 'react'
import Link from 'next/link'

import styles from '../../../styles/SingleProductReviewsSection.module.less'

interface IImageDisplay {
  url: string
  title: string
}

interface IImageGridProps {
  imageURLs: IImageDisplay[]
}

const ImageGrid: FC<IImageGridProps> = (props) => {
  const { imageURLs } = props

  if (!imageURLs.length) {
    return null
  }

  return (
    <div className={styles['review-modal-image-grid']}>
      {
        imageURLs.map((url) => (
          <Link
            key={`${url.title}-${url.url}`}
            className={styles['image-grid-item']}
            href={url.url}
            target="_blank"
          >
            <Image
              className={styles['image-grid-item-image']}
              src={url.url}
              alt={url.title}
              title={url.title}
              sizes="20%"
              fill
              unoptimized // Curb memory cost of image optimization
              // (context: this was necessary on DRC; all review images are light-ish, ~40kB)
            />
          </Link>
        ))
      }
    </div>
  )
}

export default ImageGrid
